import Config from '@config';
import { initializeDepartmentsApi } from '@gasbi/shared/common/features/departments';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const {
  departmentsApi,
  useGetDepartmentsQuery,
  useGetDepartmentByIdQuery,
  useCreateDepartmentMutation,
  useUpdateDepartmentMutation,
  useDeleteDepartmentByIdMutation,
  useGetDepartmentsIInfiniteQuery,
} = initializeDepartmentsApi({
  baseUrl: Config.VITE_API_CLIENT_URL,
  baseQuery: axiosBaseQuery,
});
